import QRCode from 'qrcode';
import { QUIZ_URL } from '../constants/site';

let cachedDataUrl: string | null = null;
let loadingPromise: Promise<string> | null = null;

export function preloadQuizQr(): Promise<string> {
  if (cachedDataUrl) return Promise.resolve(cachedDataUrl);
  if (!loadingPromise) {
    loadingPromise = QRCode.toDataURL(QUIZ_URL, {
      width: 512,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: {
        dark: '#0a0a0a',
        light: '#ffffff',
      },
    }).then((url) => {
      cachedDataUrl = url;
      return url;
    });
  }
  return loadingPromise;
}

export function getCachedQuizQr(): string | null {
  return cachedDataUrl;
}

export async function waitForCardQrImage(cardEl: HTMLElement): Promise<void> {
  await preloadQuizQr();
  const qrImg = cardEl.querySelector('img[data-share-qr]');
  if (qrImg instanceof HTMLImageElement && !qrImg.complete) {
    await new Promise<void>((resolve) => {
      qrImg.onload = () => resolve();
      qrImg.onerror = () => resolve();
    });
  }
}